import { render, staticRenderFns } from "./CustomerWorkflow.vue?vue&type=template&id=c71fa344"
import script from "./CustomerWorkflow.vue?vue&type=script&lang=js"
export * from "./CustomerWorkflow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports